// @flow
import { setIn } from 'timm'
import * as roles from './roles'
import type {
  CanDos,
  Role,
  PagePermissionsArray,
  PagePermissionsWithActions
} from '../../types/Role'

export default function hasUserPermissions (
  userRoles: Array<Role> = [],
  pagePermissions: PagePermissionsArray = []
): boolean {
  let hasUserPermissions = true
  const isUserLoggedIn = userRoles.length > 0
  // go here only if we have specific permission requirements
  if (pagePermissions.length > 0) {
    hasUserPermissions = false
    for (
      let i = 0, pagePermission;
      (pagePermission = pagePermissions[i]);
      i++
    ) {
      // will grant permission if user has any role (she's logged in) and LOGGED_IN is required
      if (pagePermission === roles.LOGGED_IN) {
        hasUserPermissions = isUserLoggedIn
        break
      }
      // will grant permission if user has no roles (she's logged out) if LOGGED_OUT is required
      if (pagePermission === roles.LOGGED_OUT) {
        hasUserPermissions = !isUserLoggedIn
        break
      }
      // will grant permission if user has any of the page permissions
      if (userRoles.includes(pagePermission)) {
        hasUserPermissions = true
        break
      }
    }
  }
  return hasUserPermissions
}

export function canDo (
  userRoles: Array<Role> = [],
  pagePermissions: PagePermissionsWithActions
): CanDos {
  return (
    Object.entries(pagePermissions)
      // $FlowFixMe usual Object.entries stuff
      .reduce(
        (canDos, [action, requiredRoles]: [string, PagePermissionsArray]) =>
          setIn(canDos, [action], hasUserPermissions(userRoles, requiredRoles)),
        {}
      )
  )
}
